import { LabelType, Options } from '@angular-slider/ngx-slider';
import { Component, ElementRef, Inject, Injector, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IInsurance, IInsuranceDic, IInsuranceSelected, InsurancesDic, InsurancesEnum, IInsuranceRequestCredit } from '../configuration-panel/interfaces/aseguradoras';
import { Subscription, firstValueFrom } from 'rxjs';
import { emailTip, emailTipTo, whatsTip } from '../configuration-panel/helpers/constants';
import { SummaryService } from 'src/app/services/summary.service';
import { ModalService } from 'src/app/services/modal-service.service';
import { StrappiService } from 'src/app/services/strappi.service';
import { ActivatedRoute, Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';
import { SecurityService } from 'src/app/services/security.service';
import { CatalogsService } from 'src/app/services/catalogs.service';
import { CotizadorService } from 'src/app/services/cotizador.service';
import { MatDialog } from '@angular/material/dialog';
import { DataService } from 'src/app/services/data.service';
import { DOCUMENT } from '@angular/common';
import { Icons } from '../modal-alert/enums';
import { ModalComponent } from '../configuration-panel/modal/modal.component';
import { IResponse } from '../configuration-panel/interfaces/IResponse';
import { canNotPreauth } from '../configuration-panel/helpers/Utils';
import { CotizadorCreditoService } from 'src/app/services/cotizador-credito.service';
import { SUSTITUECAROPTS, BINARY_OBJ, MAINTENANCE_RANGE, TypeQuoterCredit, KEY_MONTHS, INSURANCE_PAYMENT_TYPE_OPTS_MAP, ErrorBuro } from 'src/app/utils/utils';
import { State } from 'src/app/pages/buro/interfaces/states.model';
import moment from 'moment';
import { ResponsePlusCredit } from 'src/app/model/http/servicesPlus.model';
import { TourService } from "ngx-ui-tour-md-menu";
import { BALLON_TOUR, TRADITION_TOUR } from 'src/app/utils/tour-product';


@Component({
  selector: 'app-configuration-panel-credit',
  templateUrl: './configuration-panel-credit.component.html',
  styleUrls: ['./configuration-panel-credit.component.scss']
})
export class ConfigurationPanelCreditComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('contentResume') private readonly contentResume!: ElementRef;
  @ViewChild('inputCodigoPostal') private readonly zipContent!: ElementRef;
  @Input() car!: any;
  @Input() metaUrl!: any;
  @Input() slashedUrl:string = '';
  readonly totalInsuranceResponses = 3;
  /* Catalogo estados */
  private states: State[] = [];
  /* Enganche */
  public hitchPriceFloor: number = 0;
  public hitchPriceCeil: number = 0;
  public valueHitch: number = 0;
  public optionsHitch: Options = {
    floor: this.hitchPriceFloor,
    ceil: this.hitchPriceCeil,
    translate: (value: number, label: LabelType): string => {
      return '$' + value.toLocaleString('en');
    },
  };

  /* Ballon */
  public ballonFloor: number = 0;
  public ballonCeil: number = 0;
  public valueBallon: number = 10;
  public optionsBallon: Options = {
    floor: this.ballonFloor,
    ceil: this.ballonCeil,
    translate: (value: number, label: LabelType): string => {
      return value.toLocaleString('en') + '%';
    },
  };

  /* Anualidad */
  public annuityFloor: number = 0;
  public annuityCeil: number = 0;
  public annuityValue: number = 0;
  public optionsAnnuity: Options = {
    floor: this.hitchPriceFloor,
    ceil: this.hitchPriceCeil,
    translate: (value: number, label: LabelType): string => {
      return '$' + value.toLocaleString('en');
    },
  };

  dataKm: any[] = [];
  defaultValueKm = 20000;
  KmArray: any[] = [];
  defaultKm = '0';

  private customerTypeId: string = 'B';
  /* Estado */
  private defaultState!: State;
  public stateSelected?: State;
  /* Seguro */
  public insurances: IInsurance[][] = [];
  public insuranceSelected: IInsuranceSelected = {
    data: [],
    insurance: InsurancesDic[2],
  };
  private insuranceRequest!: IInsuranceRequestCredit;
  public completedResponses = 0;
  private insuranceBetter: IInsuranceDic = InsurancesDic[2];
  private suma: number = 0;

  private atlas!: any;
  private gnp!: any;
  private qualitas!: any;

  public flagProtectionPlus: boolean = false;
  public flagSubstituteCar: boolean = true;
  public flagMaintenance: boolean = false;
  public flagAnual: boolean = false;
  public flagGps: boolean = true;
  public flagGpsRequired: boolean = false;
  public loadingServicesPlus: boolean = true; // Check Service protection plus
  public optionsInsuranceType = INSURANCE_PAYMENT_TYPE_OPTS_MAP;
  public valueInsuranceType: number = INSURANCE_PAYMENT_TYPE_OPTS_MAP[1].id;
  public valueAnnuityPaymentMonth: number;
  public optionsSubstituteCar = SUSTITUECAROPTS;
  public valueSubstituteCar: number = SUSTITUECAROPTS[0].value;

  public dataQuoter: any;
  public deadlineSelect: any;
  private subscriptionDeadlineSelect!: Subscription;
  public subscriptionInteraction!: Subscription;
  public subscriptionTour!: Subscription;
  
  private readonly userId: string = '';

  public emailTip = emailTip;
  public whatsTip = whatsTip;
  public emailTipTo = emailTipTo;
  
  public showDetails = false;
  public showDetailsSecure = false;
  public disable = true;


  public screenWidth = window.innerWidth;
  public subscriptionScreen!: Subscription;
  private subscriptionUrlParams!: Subscription;
  private actionSubscriptionBalloon!: Subscription;


  public summaryService!: SummaryService;
  private modalService: ModalService;
  private strappiService: StrappiService;
  private route: ActivatedRoute;
  private keycloakService: KeycloakService;
  public personalizaStrappi: any;

  public codePromo: string = '';
  public codePostal: string = '';
  public codeStatus: string = '';
  public showCode: boolean = false;

  private readonly templateSuffix = environment.templateSuffix;
  private clickEventsubscription!: Subscription;

  private securityService: SecurityService;

  public months = KEY_MONTHS;
  public checkIncomes = BINARY_OBJ;
  public checkIncomeValue = true;
  public hasDefaultUserType = false;
  public hasMaintenance: boolean = true;
  public firtsCharge:boolean = true;
  public loadZip:boolean = false;
  public cpStorage:any;
  public servicesPlusData:ResponsePlusCredit | null = null;
  public secureLoad:boolean = true;

  public stepsTourTraditional:any = TRADITION_TOUR;
  public stepsTourBallon:any = BALLON_TOUR
  public flagAutoSuRequired: boolean = true;
  public flagAutoSusRequired: boolean = true;

  constructor(
    private activatedRoute: ActivatedRoute,
    private catalogsService: CatalogsService,
    private cotizadorService: CotizadorService,
    private cotizadorCreditoService: CotizadorCreditoService,
    public dialog: MatDialog,
    private dataService: DataService,
    private router: Router,
    @Inject(DOCUMENT) private document:any,
    private injector: Injector,
    private readonly tourService: TourService,
  ) {
    this.userId = this.dataService.getIdKeycloak();
    this.summaryService = this.injector.get<SummaryService>(SummaryService);
    this.modalService = this.injector.get<ModalService>(ModalService);
    this.strappiService = this.injector.get<StrappiService>(StrappiService);
    this.route = this.injector.get<ActivatedRoute>(ActivatedRoute);
    this.keycloakService = this.injector.get<KeycloakService>(KeycloakService);
    this.securityService = this.injector.get<SecurityService>(SecurityService);
    this.clickEventsubscription = this.dataService.getSharedFunction().subscribe((data) => {
      if (data === 'preauthorize') {
        this.preauthorize();
      }
    });

    // Se deshabilita el mes siguiente al actual, para evitar el bug del Excel de la calculadora.
    let monthTruncate = ((moment().month() + 1) === 12) ? 0 : (moment().month() + 1);
    this.months = KEY_MONTHS.filter((month) => monthTruncate !== month.id);
    this.valueAnnuityPaymentMonth = moment().month();
  }


  checkHasMaintenance() {
    let hasMaintenance = true;
    for (let maintenanceKMIndex = MAINTENANCE_RANGE.MIN; maintenanceKMIndex <= MAINTENANCE_RANGE.MAX; maintenanceKMIndex+= 10) {
      if (this.car[`amountRenting${maintenanceKMIndex}k`] === 0) {
        hasMaintenance = false;
        break;
      }
    }
    this.hasMaintenance = hasMaintenance;
  }

  get costProtectionPlus() {
    if (!this.servicesPlusData) {
      return 0;
    }

    if (!this.deadlineSelect?.period) {
      return 0;
    }

    return this.servicesPlusData.data[this.deadlineSelect.period].protectionPlus;
  }

  get costSubstituteCar() {
    if (!this.servicesPlusData) {
      return 0;
    }

    if (!this.deadlineSelect?.period) {
      return 0;
    }

    return this.servicesPlusData.data[this.deadlineSelect.period].sustituteCar;
  }

  ngOnInit(): void {

    this.tourService.initialize(this.productType===TypeQuoterCredit.ballon?this.stepsTourBallon:this.stepsTourTraditional);


    this.subscriptionTour = this.tourService.events$.subscribe(x => {
      if (x.name==='end') {
        localStorage.setItem(
          'tourProduct',
          this.securityService.encryptData(true, false)
        );
      }
    });

    

    this.checkHasMaintenance();
    setTimeout(() => {
      this.getUrlParams();
    }, 1500);

    this.subscriptionDeadlineSelect = this.dataService
      .getDeadlineSelect()
      .subscribe((resSelect: object) => {
        try {
          this.deadlineSelect = resSelect;
          this.dataService.setShowShareLink(false);
          if (this.deadlineSelect && this.deadlineSelect.isSelected) {
            setTimeout(() => {
              this.scrollToResume();
            }, 100);
          }
        } catch (error) {
          console.error('Error fetching deadline select:', error);
        }
      });

    this.subscriptionInteraction = this.dataService
      .getInteractionUserPanel()
      .subscribe((resp) => (this.disable = resp));
    this.subscriptionScreen = this.dataService
      .getScreenSize()
      .subscribe((resp) => (this.screenWidth = resp));

    this.strappiService.getPlanPage().subscribe((res: any) => {
      this.personalizaStrappi = res.panel_config;
    });

    this.actionSubscriptionBalloon = this.dataService.getBalloonMax().subscribe(data => {
      this.executeAction(data);
    });
  }

  async ngOnChanges(changes: any) {
    if (
      changes.car &&
      changes.car.currentValue?.id !== changes.car.previousValue?.id
    ) {
      this.dataQuoter = null;
      this.interactionUser();
      this.getUrlParams();
      this.getState();
      this.getCreditRangesKM();
      this.getHitchRange();
    }
  }

  ngOnDestroy(): void {
    this.subscriptionDeadlineSelect?.unsubscribe();
    this.subscriptionInteraction?.unsubscribe();
    this.subscriptionScreen?.unsubscribe();
    this.destroyObservableUrlParams();
    this.clickEventsubscription.unsubscribe();
    this.subscriptionTour.unsubscribe();
    this.actionSubscriptionBalloon.unsubscribe();
  }

  private async getUrlParams() {
    this.subscriptionUrlParams = this.route.queryParams.subscribe(async (params) => {
      let paramsQuote = params['quote'] ? this.securityService.decryptData(params['quote']) : null;

      let _idkeycloak = await this.dataService.getIdKeycloak();
      if (paramsQuote?.origin === 'A' && (_idkeycloak.includes('hunnur') || _idkeycloak.includes('ford'))) {
        paramsQuote = null;
        this.router.navigate(['/buscador'], { queryParams: {} });
        return;
      }
      if (paramsQuote?.origin === 'B' && !(_idkeycloak.includes('hunnur') || _idkeycloak.includes('ford'))) {
        paramsQuote = null;
        this.router.navigate(['/buscador'], { queryParams: {} });
        return;
      }


      if (paramsQuote.typeSustituteCar) {
        this.substituteCarSelect(paramsQuote.typeSustituteCar);
      }

      if (paramsQuote.stateId) {
        this.defaultState = this.states.find(
           (ele) => ele.id === paramsQuote.stateId
        )!;
      }
      
      if (paramsQuote.customerTypeId) {
        this.hasDefaultUserType = true;
        this.customerTypeId = paramsQuote.customerTypeId;
      }

      if (paramsQuote.insurance) {
        this.insuranceSelected.insurance = InsurancesDic.find(
          (ele) => ele.value === paramsQuote.insurance
        );
        this.setDataDeadline(
          [
            {
              key: 'insurance',
              value: this.insuranceSelected.insurance?.value,
            },
          ],
          true
        );
      }

      if (paramsQuote.downPayment) {
        this.hitchChange({ value: paramsQuote.downPayment });
      }

      if(paramsQuote.annuity) {
        this.annuityChange({value: paramsQuote.annuity});
      }

      if(paramsQuote.ballon) {
        this.ballonChange({value: paramsQuote.ballon});
      }

      if (paramsQuote.protectionPlus) {
        this.flagProtectionPlus = paramsQuote.protectionPlus;
        this.changeToggle(1, { checked: paramsQuote.protectionPlus });
      }

      if (paramsQuote.substituteCar) {
        this.flagSubstituteCar = paramsQuote.substituteCar;
        this.changeToggle(2, { checked: paramsQuote.substituteCar });
      }

      if (paramsQuote.includeMaintenance) {
        this.flagMaintenance = paramsQuote.includeMaintenance;
        this.changeToggle(3, { checked: paramsQuote.includeMaintenance });
      }
    });
  }

  private async getState() {    
    this.catalogsService.getStates().subscribe(({ data }) => {
      this.states = data;

      this.cpStorage = this.securityService.decryptData(localStorage.getItem('cpCredit'));
      if (this.cpStorage) {
        this.codePostal = this.cpStorage.cp;
        this.defaultState = this.cpStorage.idState;
        this.stateSelect(this.cpStorage.idState, false);
      }
    });
  }

  private async getCreditRangesKM() {
    this.catalogsService.getCreditRangeKm().subscribe((res) => {
      const  activeRanges = res.data.filter((item) => item.status);
      const KmArray = activeRanges.map(({range}) => range.toLocaleString('en'));
      this.KmArray = KmArray;
      const [ defaultKm ] = this.KmArray;
      this.defaultKm = defaultKm;
      this.defaultValueKm = Number(this.defaultKm.split(',').join(''));
      this.dataService.setKm(this.defaultValueKm);
      this.setDataDeadline(
        [
          { key: 'km', value: this.defaultValueKm }
        ],
        this.insuranceSelected.insurance?.value ? true : false
      );
    });
  }

  public async getZipCode( zipcode: string ) {
    try {
      const { resultados } = await firstValueFrom(this.catalogsService.getZipCode(zipcode));
      const [ firstResult ] = resultados;
      const stateSelected = this.states.find(({ idDaVinci }) => idDaVinci === Number(firstResult.idState));
      if (stateSelected) {
        localStorage.setItem(
          'cpCredit',
          this.securityService.encryptData({cp: this.codePostal, idState:stateSelected }, false)
        );
        this.stateSelect(stateSelected, true);
      }
      this.loadZip = false;
    } catch (error) {
      this.loadZip = false;
      const msg =
        'Código postal no encontrado, para continuar por favor ingresa otro código postal.';
      this.modalService.showAlertWithoutIds(
        msg,
        Icons.error,
        false,
        '¡Lo sentimos!'
      );
    }
  }

  private getHitchRange() {
    if (this.productType === 'TRADITIONAL') {
      this.cotizadorCreditoService.getRangeHitchTraditional({
        carId: this.car.id, 
        customerTypeId: this.customerTypeId, 
        productTypeId: TypeQuoterCredit.traditional
      }).subscribe({
        next: async (res) => {
          this.hitchPriceFloor = Math.floor(res.min);
          this.hitchPriceCeil = Math.ceil(res.max);

          if (this.valueHitch > this.hitchPriceCeil) {
            this.valueHitch = this.hitchPriceCeil;
          } else if(this.valueHitch < this.hitchPriceFloor) {
            this.valueHitch = this.hitchPriceFloor;
          }
    
          this.optionsHitch = {
            ...this.optionsHitch,
            floor: this.hitchPriceFloor,
            ceil: this.hitchPriceCeil
          }

          await this.checkGPSRequired(); /* TODO: FASE 2 */
          this.getRangeAnnuity(this.valueHitch);
        },
        error: (err) => {
          console.error('Error en getRangeHitchTraditional:', err);
          console.log('En caso de error, intentamos continuar con valores por defecto 0');
          // En caso de error, intentamos continuar con valores por defecto
         /*  this.hitchPriceFloor = 0;
          this.hitchPriceCeil = this.car.priceWithIva * 0.8; // 80% del precio como máximo
          this.valueHitch = this.hitchPriceFloor;
          
          this.optionsHitch = {
            ...this.optionsHitch,
            floor: this.hitchPriceFloor,
            ceil: this.hitchPriceCeil
          }
          
          // Continuamos con la secuencia
          this.getRangeAnnuity(this.valueHitch); */
        }
      });
    } else {
      this.cotizadorCreditoService.getRangeHitchBallon({
        carId: this.car.id, 
        customerTypeId: this.customerTypeId, 
        productTypeId: TypeQuoterCredit.ballon,
        ballon: this.valueBallon / 100,
        downPayment: this.valueHitch,
        code: this.codePromo
      }).subscribe({
        next: async (res) => {
          this.hitchPriceFloor = Math.floor(res.min);
          this.hitchPriceCeil = Math.ceil(res.max);

          let changeValueHitch = true;
          if (this.valueHitch > this.hitchPriceCeil) {
            this.valueHitch = this.hitchPriceCeil;
            changeValueHitch = true;
          } else if(this.valueHitch < this.hitchPriceFloor) {
            this.valueHitch = this.hitchPriceFloor;
            changeValueHitch = true;
          }
    
          this.optionsHitch = {
            ...this.optionsHitch,
            floor: this.hitchPriceFloor,
            ceil: this.hitchPriceCeil
          }

          if (changeValueHitch) {
            this.getRangeBallon(this.valueHitch);
          } else {
            await this.checkGPSRequired(); /* TODO: FASE 2 */
            this.setDataDeadline(
              [
                { key: 'ballon', value: this.valueBallon / 100 },
                { key: 'downPayment', value: this.valueHitch },
                { key: 'includeGps', value: this.flagGps },
                { key: 'customerTypeId', value: this.customerTypeId },
              ],
              this.secureLoad ? true : false
            );
          }
        },
        error: (err) => {
          console.error('Error en getRangeHitchBallon:', err);
          console.log('En caso de error, intentamos continuar con valores por defecto' );
          
          // En caso de error, intentamos continuar con valores por defecto
         /*  this.hitchPriceFloor = 0;
          this.hitchPriceCeil = this.car.priceWithIva * 0.8;
          this.valueHitch = this.hitchPriceFloor;
          
          this.optionsHitch = {
            ...this.optionsHitch,
            floor: this.hitchPriceFloor,
            ceil: this.hitchPriceCeil
          }
          
          // Continuamos con la secuencia
          this.getRangeBallon(this.valueHitch); */
        }
      });
    }
  }

  /* TODO: FASE 2 */
  private async checkGPSRequired() {
    try {
      const isGPSRequired = await this.cotizadorCreditoService.getCreditGPSRequired({
        carId: this.car.id,
        customerTypeId: this.customerTypeId,
        downPayment: this.valueHitch
      }).toPromise();
  
      this.flagGpsRequired = Boolean(isGPSRequired);
      if (isGPSRequired) {
        this.flagGps = this.flagGpsRequired || this.flagGps;
      }

      return isGPSRequired;
    } catch (error) {
      console.log('Error checking GPS required', error);
      return false;
    }
  }

  private calculateSecureLoad(): boolean {
    // Verificamos si tenemos los datos mínimos necesarios para generar una cotización
    const hasMinimalData = this.car?.id && this.stateSelected?.id;
    
    // Si tenemos datos mínimos, permitimos continuar incluso sin seguros completados
    if (hasMinimalData) {
      return true;
    }
    
    // Si no tenemos datos mínimos, solo continuamos si tenemos seguros completados
    return this.completedResponses === this.totalInsuranceResponses || this.insuranceSelected.insurance?.value ? true : false;
  }

  private getRangeAnnuity( valueHitch: number ){
    this.cotizadorCreditoService.getRangeAnnuity(this.car.id, this.customerTypeId, TypeQuoterCredit.traditional, valueHitch).subscribe({
      next: (res) => {
        this.annuityFloor = Math.ceil(res.min);
        this.annuityCeil = Math.floor(res.max);

        if (this.annuityValue < this.annuityFloor || this.annuityValue > this.annuityCeil) {
          this.annuityValue = this.annuityFloor;
        }

        this.optionsAnnuity = {
          ...this.optionsAnnuity,
          floor: this.annuityFloor,
          ceil: this.annuityCeil
        }

        this.secureLoad = this.calculateSecureLoad();

        this.setDataDeadline(
          [
            { key: 'annuity', value: this.annuityValue },
            { key: 'downPayment', value: this.valueHitch },
            { key: 'includeGps', value: this.flagGps },
            { key: 'customerTypeId', value: this.customerTypeId },
          ],
          this.secureLoad ? true : false
        );
      },
      error: (err) => {
        console.error('Error en getRangeAnnuity:', err);
        console.log('En caso de error, intentamos continuar con valores por defecto 1');
        // En caso de error, establecemos valores por defecto y continuamos
        this.annuityFloor = 0;
        this.annuityCeil = this.car.priceWithIva * 0.5; // 50% del precio como máximo
        this.annuityValue = this.annuityFloor;
        
        this.optionsAnnuity = {
          ...this.optionsAnnuity,
          floor: this.annuityFloor,
          ceil: this.annuityCeil
        }

        this.secureLoad = this.calculateSecureLoad();

        // Continuamos con la secuencia
        this.setDataDeadline(
          [
            { key: 'annuity', value: this.annuityValue },
            { key: 'downPayment', value: this.valueHitch },
            { key: 'includeGps', value: this.flagGps },
            { key: 'customerTypeId', value: this.customerTypeId },
          ],
          this.secureLoad ? true : false
        );
      }
    });
  }

  private getRangeBallon( valueHitch: number ) {
    
      this.cotizadorCreditoService.getRangeBallon({
        carId: this.car.id,
        customerTypeId: this.customerTypeId,
        code: this.codePromo,
        downPayment: valueHitch
      }).subscribe({
        next: async (res) => {
          
          this.ballonFloor = Math.floor(res.minPercent * 100);
          this.ballonCeil = this.ballonCeil;
   
          let changeBallon = false;
          if (this.valueBallon < this.ballonFloor) {
            this.valueBallon = this.ballonFloor;
            changeBallon = true;
          } else if (this.valueBallon > this.ballonCeil) {
            this.valueBallon = this.ballonCeil;
            changeBallon = true;
          }
    
          this.optionsBallon = {
            ...this.optionsBallon,
            floor: this.ballonFloor,
            ceil: this.ballonCeil
          }

          if (changeBallon) {
            this.getHitchRange();
          } else {
            await this.checkGPSRequired(); /* TODO: FASE 2 */
            this.secureLoad = this.calculateSecureLoad();
            this.setDataDeadline(
              [
                { key: 'ballon', value: this.valueBallon / 100 },
                { key: 'downPayment', value: this.valueHitch },
                { key: 'includeGps', value: this.flagGps },
                { key: 'customerTypeId', value: this.customerTypeId },
              ],
              this.secureLoad ? true : false
            );
          }
    
        },
        error: (err) => {
          console.error('Error en getRangeBallon:', err);
          console.log('En caso de error, intentamos continuar con valores por defecto 2');
          // En caso de error, establecemos valores por defecto y continuamos
          this.ballonFloor = 10;
          this.ballonCeil = 50;
          this.valueBallon = this.ballonFloor;
          
          this.optionsBallon = {
            ...this.optionsBallon,
            floor: this.ballonFloor,
            ceil: this.ballonCeil
          }

          this.secureLoad = this.calculateSecureLoad();
          
          // Continuamos con la secuencia
          this.setDataDeadline(
            [
              { key: 'ballon', value: this.valueBallon / 100 },
              { key: 'downPayment', value: this.valueHitch },
              { key: 'includeGps', value: this.flagGps },
              { key: 'customerTypeId', value: this.customerTypeId },
            ],
            this.secureLoad ? true : false
          );
        }
      });
  }

  public async hitchChange(event: any) {
    this.valueHitch = event.value;
    if (Number(this.valueHitch) || this.valueHitch === 0){
      if (this.productType === 'TRADITIONAL') { 
        await this.checkGPSRequired(); /* TODO: FASE 2 */
        this.getRangeAnnuity(this.valueHitch);
      } else {
        this.getRangeBallon(this.valueHitch);
      }
    } else {
      this.valueHitch = 0;
    }
  }


  public changeInputHitch(event: any) {
    const hitch = parseInt(event.target.value);
    this.valueHitch = Math.max(this.hitchPriceFloor, Math.min(this.hitchPriceCeil, hitch));
    if (Number(this.valueHitch) || this.valueHitch === 0){
      if (this.productType === 'TRADITIONAL') { 
        this.getRangeAnnuity(this.valueHitch);
      } else {
        this.getRangeBallon(this.valueHitch);
      }
    } else {
      this.valueHitch = 0;
    }
  }

  public annuityChange(event: any) {
    this.annuityValue = event.value;
    if (Number(this.annuityValue)){
      this.setDataDeadline([{ key: 'annuity', value: event.value }], true);
    } else {
      this.valueHitch = 0;
    }
  }

  public changeInputAnnuity(event: any) {
    const annuityValue= Number(event.target.value);
    this.annuityValue = Math.max(this.annuityFloor, Math.min(this.annuityCeil, annuityValue));
    if (this.annuityValue) {
      this.setDataDeadline([{ key: 'annuity', value: this.annuityValue }], true);
    } else {
      this.annuityValue = 0;
    }
  }

  public ballonChange(event: any) {
    this.valueBallon = event.value;
    if (Number(this.valueBallon) || this.valueBallon === 0){
      this.getHitchRange();
    } else {
      this.valueBallon = 0;
    }
  }

  public changeInputBallon(event: any) {
    this.valueBallon = Number(event.target.value);
    if (Number(this.valueBallon)){
      this.getHitchRange();
    } else {
      this.valueBallon = 0;
    }
  }

  private getServicesPlus() {
    this.loadingServicesPlus = true;
    this.cotizadorCreditoService
      .getServicesPlus({
        carId: this.car.id,
        km: this.defaultValueKm,
        cTiD: this.customerTypeId,
        typeSuitCar: this.valueSubstituteCar,
        stateId: this.stateSelected!.id,
        insurance: this.insuranceSelected.insurance?.value,
        cpTip: this.codePostal,
        quoterType: this.productType,
        downPayment: this.valueHitch,
        insuranceType: this.valueInsuranceType,
      })
      .subscribe({
        next: (res:any) => {
          this.servicesPlusData = res;
          this.loadingServicesPlus = false;
        },
        error: (err: any) => {
          console.log('Error getting services plus', err);
          this.resetProperties();
        }
      });
  }

  public changeToggle(type: number, event: any) {
    let key = '';

    const typeKeyMap: {[key: number]: string} = {
      1: 'protectionPlus',
      2: 'substituteCar',
      4: 'includeGps',
      5: 'includeAnnuities'
    }

    key = typeKeyMap[type] || 'includeMaintenance';

    this.interactionUser();
    this.setDataDeadline([{ key, value: event.checked }], true);
  }

  openDialog() {
    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        insuranceSelected: this.insuranceSelected.insurance,
        insuranceBetter: this.insuranceBetter,
        isAfin: false, // TODO: Check this
      },
      panelClass: 'custom-modalbox',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && this.insuranceSelected.insurance !== result.insurance) {
        this.insuranceSelected = result;
        this.setDataDeadline(
          [
            {
              key: 'insurance',
              value: this.insuranceSelected.insurance?.value,
            },
          ],
          true
        );
        this.interactionUser();
      }
    });
  }

  private resetProperties() {
    this.dataService.setDeadlineCreditSelect(null);
    this.gnp?.unsubscribe();
    this.atlas?.unsubscribe();
    this.qualitas?.unsubscribe();
    this.insurances = [];
    this.insuranceSelected = {
      data: [],
      insurance: undefined,
    };
    this.completedResponses = 0;
    this.loadingServicesPlus = false;
    this.cotizadorService.insurnaces.next([]);
    this.cotizadorService.insuranceDic.next(InsurancesDic[2]);
  }

  private firstResponse(resp: IResponse | any) {
    if (!resp.hasOwnProperty('data')) {
      if (this.completedResponses === this.totalInsuranceResponses) {
        if (this.suma === 0) {
          this.getServicesPlus();
          this.setDataDeadline(
            [
              { key: 'cpTip', value: this.codePostal },
              { key: 'stateId', value: this.stateSelected!.idTip },
              { key: 'stateName', value: this.stateSelected!.stateName },
              { key: 'insurance', value: null }
            ],
            true
          );

        }
      }
      return;
    }

    const { data } = resp;

    let { error, ...op } = data;

    let info: IInsurance[] = Object.values(op);

    this.insurances.push(info);
    this.cotizadorService.insurnaces.next(this.insurances);
    const insurance = InsurancesDic.find(
      (ele) => ele.key === info[0]!.insurance
    );
    if (this.insuranceSelected.insurance === undefined) {
      this.insuranceSelected.data = info;
      this.insuranceSelected.insurance = insurance;
      this.cotizadorService.insuranceDic.next(insurance!);
      this.getServicesPlus();
      this.setDataDeadline([], this.firtsCharge ? (this.cpStorage===null ? true : this.calculateSecureLoad() ? true : false ) : true);
      this.firtsCharge = false;
    }
  }


  public resultOfRequestNotSuccess() {
    this.suma = this.insurances.length;
    if (this.completedResponses === this.totalInsuranceResponses && this.suma === 0) {
      
      return;
    } else {
      this.dataService.sendSharedFunction(false);
      return false;

    }
  }

  public insuranceTypeSelect(value: any) {
    this.valueInsuranceType = value;
    this.setDataDeadline(
      [{ key: 'insuranceType', value: this.valueInsuranceType }],
      true
    );
  }

  public substituteCarSelect(value: any) {
    this.valueSubstituteCar = value;
    this.getServicesPlus();
    this.setDataDeadline(
      [{ key: 'typeSustituteCar', value: this.valueSubstituteCar }],
      true
    );
  }

  public kmSelect(value: any) {
    this.defaultKm = value;
    
    const km = Number(value.split(',').join(''));
    this.defaultValueKm = km;
    
    this.getServicesPlus();
    this.dataService.setKm(km); 
    this.setDataDeadline(
      [{ key: 'km', value: this.defaultValueKm }],
      true
    );
  }

  public checkIncomesChanges(value: boolean) {
    this.customerTypeId = value ? 'B' : 'CLIENTE SIN';
    this.getHitchRange();
  }

  public selectAnnualPaymentMonth(monthIndex: number, flagChangeData: boolean) {
    this.valueAnnuityPaymentMonth = monthIndex;
    this.setDataDeadline(
      [
        { key: 'annuityPaymentMonth', value: this.valueAnnuityPaymentMonth }
      ],
      flagChangeData
    );
  }

  public stateSelect(state: State, flagChangeData: boolean) {
    this.stateSelected = state;
    const { idTip, year, priceWithIva } = this.car;
    this.resetProperties();
    this.setDataDeadline(
      [
        { key: 'cpTip', value: this.codePostal },
        { key: 'stateId', value: this.stateSelected.id },
        { key: 'stateName', value: this.stateSelected.stateName }
      ],
      this.insuranceSelected.insurance?.value!==undefined ? flagChangeData : false
    );

    this.insuranceRequest = {
      cpTip: this.codePostal,
      idState: this.stateSelected.id,
      priceWithIva,
      insurance: InsurancesEnum.GNP,
      idTip,
      year,
      quoterType: this.productType,
    };
    
    const requestGNP = {
      ...this.insuranceRequest,
      insurance: InsurancesEnum.GNP,
    };    
    const requestAtlas = {
      ...this.insuranceRequest,
      insurance: InsurancesEnum.ATLAS,
    };    
    const requestQualitas = {
      ...this.insuranceRequest,
      insurance: InsurancesEnum.QUALITAS,
    };    
  
    this.gnp = this.cotizadorService
      .getCreditInsuranceInfo(requestGNP).subscribe({
        next: (resp: any): void => {
          this.completedResponses += 1;
          this.firstResponse(resp);
        },
        error: (err) => {
          console.log('Error getting GNP insurance', err);
        }
      });

    this.atlas = this.cotizadorService
      .getCreditInsuranceInfo(requestAtlas).subscribe({
        next: (resp: any): void => {
          this.completedResponses += 1;
          this.firstResponse(resp);
        },
        error: (err) => {
          console.log('Error getting ATLAS insurance', err);
        }
      });
    
    this.qualitas = this.cotizadorService
      .getCreditInsuranceInfo(requestQualitas).subscribe({
        next: (resp: any): void => {
          this.completedResponses += 1;
          this.firstResponse(resp);
        },
        error: (err) => {
          console.log('Error getting QUALITAS insurance', err);
        }
      });

  }

  private setDataDeadline(dataChange: any, flagChangeData: boolean) {
    console.log('setDataDeadline ejecutándose:', { 
      dataChange, 
      flagChangeData, 
      codePostal: this.codePostal,
      carId: this.car?.id,
      stateId: this.stateSelected?.id,
      completedResponses: this.completedResponses,
      totalInsuranceResponses: this.totalInsuranceResponses,
      insuranceSelected: this.insuranceSelected.insurance?.value
    });
    
    const idTemp = this.dataQuoter?.carId || 0;
    const idCar = this.car?.id || 0;
    if (flagChangeData) {
      
      if (this.dataQuoter) {
        dataChange.forEach((item: any) => {
          this.dataQuoter[item.key] = item.value;
        });

        if (idTemp !== idCar) {
          this.dataQuoter.carId = idCar;
        }

        this.dataQuoter.quoterType = this.productType;
        this.dataQuoter.insurance = this.insuranceSelected.insurance?.value;
        this.dataQuoter.cpTip = this.codePostal;
        this.dataQuoter.stateId = this.stateSelected?.id;
        this.dataQuoter.stateName = this.stateSelected?.stateName;
      } else {
          this.dataQuoter = {
            carId: this.car.id,
            cpTip: this.codePostal,
            customerTypeId: this.customerTypeId,
            insurance: this.insuranceSelected.insurance?.value,
            insuranceType: this.valueInsuranceType,
            km: this.defaultValueKm,
            protectionPlus: this.flagProtectionPlus,
            stateId: this.stateSelected?.id,
            stateName: this.stateSelected?.stateName,
            substituteCar: this.flagSubstituteCar,
            typeSustituteCar: this.valueSubstituteCar,
            userId: this.userId,
            quoterType: this.productType,
            codePromo: this.codePromo,
            includeMaintenance: this.flagMaintenance,
            includeGps: this.flagGps,
            includeAnnuities: this.flagAnual,
            annuityPaymentMonth: this.valueAnnuityPaymentMonth,
            downPayment: this.valueHitch,
            annuity: this.annuityValue,
            pdvID: 1,
            ballon: this.valueBallon / 100
          };
      }

      // Verificamos que tengamos los datos mínimos necesarios para generar cotización
      if (this.dataQuoter && this.dataQuoter.carId && this.stateSelected?.id && this.codePostal !== '') {
        console.log('setDataDeadline: Ejecutando setQuoterData con datos:', this.dataQuoter);
        this.dataService.setQuoterData(this.dataQuoter);
        
        const showTourProduct = this.securityService.decryptData(localStorage.getItem('tourProduct'));
        if (!showTourProduct) {
          this.showAlertTour();
        }
      } else {
        console.warn('setDataDeadline: Datos insuficientes para generar cotización', {
          carId: this.dataQuoter?.carId,
          stateId: this.stateSelected?.id,
          codePostal: this.codePostal
        });
      }
      this.interactionUser()  
    }
  }

  public showAlertTour(){
    const dialogLogin = this.modalService.openAlert(
      {
        title: '¡Bienvenid@ al nuevo cotizador de Crédito BitCar!',
        content: 'Haz click en Iniciar para mostrarte como utilizarlo',
        btnAction0: 'Iniciar',
        btnAction2: 'No, gracias',
        icon: Icons.none,
        idBtnAction1: `boton-tour-producto-${this.templateSuffix !== '' ? '-b' : ''}`,
      },
      false
    );
    dialogLogin.afterClosed().subscribe((result) => {
      if (result) {
        this.tourService.start();
      }else{
        localStorage.setItem(
          'tourProduct',
          this.securityService.encryptData(true, false)
        );
      }
    });
  }

  compare() {
    if (this.userId === '') {
      this.alertLogin('Para comparar autos por favor inicia sesión o registrate');
    } else {
      const {
        idQuoter,
        concept,
        period,
        monthlyPayment,
        initialPayment,
        depositIncome,
        downPayment,
        annuity,
        finalRate,
        ballon,
        cat
      } = this.deadlineSelect;
      const { priceWithIva, subBrand, brand } = this.car;
      const { stateName } = this.stateSelected!;
      const insuranceName = this.insuranceSelected.insurance?.key;
      const dataEncrypt = {
        ...this.dataQuoter,
        stateName,
        idQuoter,
        deadlineConcept: concept,
        deadlinePeriod: period,
        monthlyPayment,
        initialPayment,
        depositIncome,
        priceWithIva,
        subBrand,
        brand,
        insuranceName,
        downPayment,
        isCredit:true,
        annuity,
        finalRate:finalRate.finalRate,
        cat
      };
      const urlHash = this.securityService.encryptData(dataEncrypt, false);
      this.router.navigate(['/comparar-unidad'], {
        queryParams: { quote: urlHash },
      });
    }
  }

  public preauthorize() {
    if (this.userId === '') {
      this.alertLogin(
        'Por favor inicia sesión o registrate para continuar con tu aprobación'
      );
    } else {
      this.sendPreauthorize();
    }
  }

  public applyCode() {
    this.disable = true;
    this.catalogsService.validateCreditCodePromo(this.codePromo).subscribe({
      next: (res) => {
        this.setDataDeadline(
          [{ key: 'codePromo', value: this.codePromo }],
          true
        );
        this.modalService.openAlert(
          {
            title: 'Código de promoción aplicado exitosamente',
            content: 'Verás reflejado el ajuste de tu mensualidad en la tabla de planes.',
            btnAction1: 'Entendido',
            btnAction2: null,
            icon: Icons.success,
            idBtnAction1: null,
            idBtnAction2: null,
          },
          false
        );
        this.codeStatus = 'valid';
      },
      error: (err) => {
        console.log('Error applying code promo', err);
        this.disable = false;
        let _error = err.error.userError;
        if (_error.includes('válido')) {
          this.codeStatus = 'invalid';
        } else if (_error.includes('vigencia')) {
          this.codeStatus = 'novalidity';
        } else if (_error.includes('inactivo')) {
          this.codeStatus = 'inactive';
        }
      },
    });
  }

  public changeCode() {
    this.codePromo = '';
    this.codeStatus = '';
    this.document.getElementById('inputCodigo')?.focus();
  }

  public keyupInputCode() {
    if (this.codeStatus === 'valid' || this.codeStatus === 'invalid')
      this.codeStatus = '';
  }

  public keyupInputCodePostal( event:any ) {
    const zipCode = event.value;
    
    if (zipCode.length === 5 && !this.loadZip) {
      this.loadZip = true;
      this.codePostal = zipCode;
      this.document.getElementById('inputCodigoPostal')?.blur();
      this.getZipCode(zipCode);
    }
  }

  private alertLogin(text: string) {
    const { concept, period } = this.deadlineSelect;
    const dataEncrypt = {
      ...this.dataQuoter,
      deadlineConcept: concept,
      dealinePeriod: period,
      isAfin: false, // TODO: Check this
      origin: environment.templateSuffix !== '' ? 'B' : 'A'
    };
    localStorage.setItem(
      'dataQuote',
      this.securityService.encryptData(dataEncrypt, false)
    );
    const dialogLogin = this.modalService.openAlert(
      {
        title: '¡Aviso!',
        content: text,
        btnAction1: 'Crear Cuenta',
        btnAction2: 'Iniciar Sesión',
        icon: Icons.info,
        idBtnAction1: `boton-aviso-crear-cuenta${this.templateSuffix !== '' ? '-b' : ''}`,
        idBtnAction2: `boton-aviso-iniciar-sesion${this.templateSuffix !== '' ? '-b' : ''}`,
      },
      false
    );
    dialogLogin.afterClosed().subscribe((result) => {
      localStorage.setItem(
        'flowType',
        this.templateSuffix === '' ? 'A' : 'B'
      );

      if (result === false) this.keycloakService.login({
        redirectUri: window.location.href
      });

      if (result === true) this.keycloakService.register({
        redirectUri: window.location.href
      });
    });
  }

  public sendPreauthorize() {
    const request = {
      quoterId: this.deadlineSelect.idQuoter,
      carId: this.car.id,
      concept: this.deadlineSelect.concept,
      period: this.deadlineSelect.period,
      depositIncome: 0,
      idKeycloak: this.dataService.getIdKeycloak(),
      priceWithIva: this.car.priceWithIva,
      monthlyPayment: this.deadlineSelect.monthlyPayment,
      update: false,
    };

    this.cotizadorService.preauthorize(request).subscribe((res) => {
      if (
        res.maxPaymentCapacity &&
        res.maxPaymentCapacity < this.deadlineSelect.monthlyPayment
      ) {
        const msg =
          'Lo sentimos, el producto que seleccionaste sobrepasa la capacidad de pago máxima que te hemos asignado. Por favor selecciona otra opción';
        this.modalService.showAlertWithoutIds(
          msg,
          Icons.error,
          false,
          '¡Aviso!'
        );
        return;
      }

      let quoterIdPrevius = res.data._source
        ? res.data._source.quoterId
        : res.data.quoterId;

      if (this.deadlineSelect.idQuoter === quoterIdPrevius)
        this.router.navigate(['/genera-oportunidad']);
      else
        this.processExists(res.data._source.carId, request, res.data._source);
    });
  }

  private processExists(idCarPrevius: any, request: any, client: any) {
    this.catalogsService.getQuoteCarById(idCarPrevius).subscribe((resCar) => {
      let carPrevius = resCar.data.hits.hits[0]._source;
      const hasHistorial = client?.E7?.data?.errors && (client?.E7?.data?.errors[0]?.cveError === ErrorBuro.NO_HISTORIAL)

      const dialogRef = this.modalService.openAlert(
        {
          title: '¡Aviso!',
          content: hasHistorial
            ? `No cuentas con historial crediticio y es requerido para poder continuar con el proceso. Gracias por tu preferencia.`
            : `Existe un proceso de pre aprobación para tu <b>${carPrevius.brand} ${carPrevius.subBrand}</b>, ¿Lo quieres sustituir?`,
          btnAction1: hasHistorial ? 'Entendido' : 'Si, lo quiero sustituir',
          btnAction2: hasHistorial ? null : 'No, ir a mi ultimo paso',
          icon: Icons.info,
          idBtnAction1: hasHistorial ? `boton-aviso-no-historial` : `boton-aviso-quiero-sustituir$`,
          idBtnAction2:  hasHistorial ? null : `boton-aviso-ir-ultimo-paso`,
        },
        true
      );
      dialogRef.afterClosed().subscribe((result) => {
        if (hasHistorial) {
          this.router.navigate(['/home']);
          return;
        }
        if (result) {
          if (canNotPreauth(client)) {
            const msg =
              'Tu cotización actual está en un paso que no se puede sustituir. Contáctanos para obtener más ayuda';
            this.modalService.showAlertWithoutIds(msg, Icons.error, false, '');
            return;
          }

          request.update = true;
          this.dataService.setUpdatePreauthorize(true);
          this.cotizadorService.preauthorize(request).subscribe((resUpdate) => {
            if (resUpdate.status === 200)
              this.router.navigate(['/genera-oportunidad']);
          });
        } else this.router.navigate(['/genera-oportunidad']);
      });
    });
  }

  private scrollToResume() {
    if (this.screenWidth > 767) {
      this.contentResume?.nativeElement.scrollIntoView({
        block: 'center',
        behavior: 'smooth',
      });
    }
  }

  public interactionUser() {
    this.dataService.setInteractionUserPanel(true);
    if (this.screenWidth <= 770 && this.stateSelected?.stateName===undefined) {
      this.zipContent?.nativeElement.scrollIntoView({
        block: 'center',
        behavior: 'smooth',
      });
    }
  }

  private destroyObservableUrlParams() {
    this.subscriptionUrlParams?.unsubscribe();
  }

  public validateBetter() {
    const isComplete = this.completedResponses === this.totalInsuranceResponses;
    const isMoreIns = this.insurances.length > 1;

    if (isComplete && isMoreIns) {
      this.compareInsurances();
      return this.insuranceBetter.key !== this.insurances[0][0].insurance;
    }
    return false;
  }

  private compareInsurances() {
    if (this.insurances.length === 0) {
      return;
    }
    try {
      const newArr = this.insurances.map((ele) =>
        ele.find((plazo) => plazo.plazo === '36')
      );
      let result = newArr.reduce((res, obj) =>
        obj!.cost < res!.cost ? obj : res
      );
      this.insuranceBetter = this.findNewBetter(result!);  
    } catch (error) {
      console.log('Error comparing insurances', error);
    }
    
  }

  private findNewBetter(insuranceToCompare: IInsurance) {
    return InsurancesDic.find(
      (ele) => ele.key === insuranceToCompare.insurance
    )!;
  }

  get productType(): string {
    const procutType = (this.activatedRoute.snapshot.params['producto'] ?? 'TRADITIONAL')  as string;
    return procutType.toUpperCase();
  }

  executeAction(plazo:any) {
    if (this.productType === 'BALLON') {
      if(this.ballonCeil != this.car[`ballon${plazo}`]*100){
          this.ballonCeil = this.car[`ballon${plazo}`]*100;           
          this.getHitchRange(); 
      }      
    }
  }
}